import { useTranslation } from "react-i18next";

import { Globe, Logo, QuestionMark } from "@/assets/icons/icons";
import { LanguageOption } from "@/components/Interface/Footer/LanguageOption";
import { LinkOption } from "@/components/Interface/Footer/LinkOption";
import { getMenuItems } from "@/components/Layout/Footer/CollapsibleLinkMenu";
import { FCC } from "@/types";

import { CollapsibleMenuItem } from "./CollapsibleMenuItem";
import { MenuItem } from "./MenuItem";

export const FooterMenu: FCC = () => {
  const { i18n, t } = useTranslation();
  const currentLanguage = i18n.resolvedLanguage;
  const menuItems = getMenuItems(t);

  const handleLanguageChange = (langCode: string) => {
    i18n.changeLanguage(langCode);
  };

  return (
    <nav className="flex flex-col gap-2 md:flex-row md:items-start smPlus:flex-row smPlus:items-center smPlus:gap-4">
      <CollapsibleMenuItem
        id="language-menu"
        icon={
          <Globe className="w-6 [&>path]:fill-white group-hover:[&>path]:fill-secondary-100 md:[&>path]:fill-primary-100" />
        }
        label={t("Common.language")}
        position="top"
        align="right"
      >
        <LanguageOption
          code={t("Common.languageCodes.enCode")}
          label={t("Languages.english")}
          selected={currentLanguage === t("Common.languageCodes.enCode")}
          onSelect={handleLanguageChange}
        />
        <LanguageOption
          code={t("Common.languageCodes.deCode")}
          label={t("Languages.german")}
          selected={currentLanguage === t("Common.languageCodes.deCode")}
          onSelect={handleLanguageChange}
        />
        <LanguageOption
          code={t("Common.languageCodes.frCode")}
          label={t("Languages.french")}
          selected={currentLanguage === t("Common.languageCodes.frCode")}
          onSelect={handleLanguageChange}
        />
      </CollapsibleMenuItem>

      <MenuItem
        mobileText={t("Common.support")}
        ariaLabel={t("Common.support")}
        icon={
          <QuestionMark className="w-6 [&>path]:fill-white [&>path]:stroke-white group-hover:[&>path]:fill-white md:[&>path]:fill-primary-100" />
        }
        link={t("Footer.support.url")}
      />
      <CollapsibleMenuItem
        id="link-menu"
        customStyles={{ iconContainer: "md:bg-secondary-100" }}
        icon={
          <Logo className="w-6 [&>path]:fill-white [&>path]:stroke-white group-hover:[&>path]:fill-secondary-100 group-hover:[&>path]:stroke-secondary-100 md:[&>path]:fill-white" />
        }
        label={t("Common.logoName")}
        position="top"
        align="right"
      >
        {menuItems.map(({ label, link }) => (
          <LinkOption key={label} label={label} href={link} />
        ))}
      </CollapsibleMenuItem>
    </nav>
  );
};
